import moment from "moment";
import {
  AUDBILITY_STATUS_CONFIG,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
} from "../constants";

// A API devolve datas como "2026-09-22T08:08:38" e "2026-09-02_16:07:39"
export const parseApiDate = (value) =>
  value ? moment(String(value).replace("_", "T")) : null;

const formatApiDate = (value, format) => {
  const date = parseApiDate(value);

  return date?.isValid() ? date.format(format) : "-";
};

export const formatDate = (value) => formatApiDate(value, DATE_FORMAT);

export const formatDateTime = (value) =>
  formatApiDate(value, DATE_TIME_FORMAT);

// A API mandava o documento em status_history[0].document; hoje manda em document
export const getUserDocument = (user) =>
  user?.document || user?.status_history?.[0]?.document || null;

export const getStatusLabel = (status) =>
  AUDBILITY_STATUS_CONFIG[status]?.label || status || "-";

export const normalizeUser = (user) => ({
  sub: user.user_sub,
  name: user.name,
  email: user.email,
  status: getStatusLabel(user.status),
  statusKey: user.status,
  createdAt: formatDate(user.date_created),
});
